import { useState, useEffect, useCallback } from 'react';
import api from '../lib/axios';

export const useWhatsApp = () => {
  const [status, setStatus] = useState('initializing');
  const [qrCode, setQrCode] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Use useCallback so we can safely include it in the useEffect dependency array
  const fetchStatus = useCallback(async () => {
    try {
      const { data } = await api.get('/whatsapp/status');
      if (data.success) {
        setStatus(data.status);
        setQrCode(data.qrCode);
      }
    } catch (error) {
      console.error("Failed to fetch status", error);
      setStatus('disconnected');
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchStatus(); // Fetch immediately on mount
    
    // Poll every 5 seconds (5000 ms) so the QR code updates before expiring
    const interval = setInterval(fetchStatus, 5000);
    
    return () => clearInterval(interval);
  }, [fetchStatus]);

  return { status, qrCode, isLoading, refresh: fetchStatus };
};